"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ButtonProps = exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _buttons = _interopRequireDefault(require("../../tools/buttons.scss"));

var _spinner = _interopRequireDefault(require("../spinner"));

// Common button
// ================
// The default button is the secondary button. Pass primary={true} to
// override.
function dashToCamelCase(string) {
  var str = string.replace(/-([a-z])/g, function (g) {
    return g[1].toUpperCase();
  });
  return str.charAt(0).toUpperCase() + str.slice(1);
}

var Button = /*#__PURE__*/function (_Component) {
  (0, _inherits2["default"])(Button, _Component);

  function Button() {
    (0, _classCallCheck2["default"])(this, Button);
    return (0, _possibleConstructorReturn2["default"])(this, (0, _getPrototypeOf2["default"])(Button).apply(this, arguments));
  }

  (0, _createClass2["default"])(Button, [{
    key: "className",
    value: function className(type) {
      var disabled = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      return _buttons["default"]["Button".concat(dashToCamelCase(type)).concat(disabled ? 'Disabled' : '')];
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          loading = _this$props.loading,
          disabled = _this$props.disabled,
          type = _this$props.type,
          className = _this$props.className,
          buttonType = _this$props.buttonType,
          ariaLabel = _this$props.ariaLabel,
          id = _this$props.id,
          dataTestId = _this$props.dataTestId,
          ariaPressed = _this$props.ariaPressed,
          onClick = _this$props.onClick,
          children = _this$props.children; // Always disabled when loading

      var isDisabled = loading || disabled;
      var classNames = (0, _classnames["default"])(this.className(type, isDisabled), className);
      var attributes = {};

      if (isDisabled) {
        attributes.disabled = 'disabled';
      }

      if (buttonType) {
        attributes.type = buttonType;
      }

      return _react["default"].createElement("button", (0, _extends2["default"])({
        onClick: onClick,
        className: classNames,
        "aria-label": ariaLabel,
        id: id,
        "data-test-id": dataTestId,
        "aria-pressed": ariaPressed
      }, attributes), loading ? _react["default"].createElement(_spinner["default"], {
        className: _buttons["default"].Spinner
      }) : _react["default"].createElement("span", {
        className: _buttons["default"].text
      }, children));
    }
  }]);
  return Button;
}(_react.Component);

exports["default"] = Button;
var ButtonProps = {
  type: _propTypes["default"].oneOf(['primary', 'secondary', 'secondary-light', 'tertiary', 'tertiary-light', 'inferior']),
  disabled: _propTypes["default"].bool,
  loading: _propTypes["default"].bool,
  children: _propTypes["default"].node,
  className: _propTypes["default"].string,
  onClick: _propTypes["default"].func,
  buttonType: _propTypes["default"].oneOf(['submit', 'reset', 'button']),
  ariaLabel: _propTypes["default"].string,
  ariaPressed: _propTypes["default"].bool,
  id: _propTypes["default"].string
};
exports.ButtonProps = ButtonProps;
Button.propTypes = ButtonProps;
Button.defaultProps = {
  type: 'primary',
  loading: false,
  disabled: false
};